import { type Dollars } from '@fruitful/types';

// Duplicated from /types/src/bills so that earnings-calculator npm run test:manual command works locally
enum BillingCadence {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    SEMI_ANNUALLY = 'SEMI_ANNUALLY',
    ANNUALLY = 'ANNUALLY',
    YEARLY = 'YEARLY',
    UNKNOWN = 'UNKNOWN',
}

export const getMonthlyBillAmount = (
    amount: Dollars = 0,
    cadence?: BillingCadence,
): Dollars => {
    if (cadence == null) {
        return amount; // until cadence is set, assume monthly
    }
    switch (cadence) {
        case BillingCadence.DAILY:
            return (amount * 365) / 12;
        case BillingCadence.WEEKLY:
            return (amount * 52) / 12;
        case BillingCadence.BI_WEEKLY:
            return (amount * 26) / 12;
        case BillingCadence.SEMI_MONTHLY:
            return amount * 2;
        case BillingCadence.SEMI_ANNUALLY:
            return amount / 6;
        case BillingCadence.ANNUALLY:
            return amount / 12;
        case BillingCadence.QUARTERLY:
            return amount / 3;
        default:
            return amount;
    }
};
